import { Dayjs } from 'lib/dayjs';
import dayjsGenerateConfig from 'rc-picker/es/generate/dayjs';
import generatePicker, {
  RangePickerProps as IRangePickerProps,
  PickerDateProps as IPickerDateProps,
  PickerTimeProps as IPickerTimeProps,
} from 'antd/es/date-picker/generatePicker';

export const DatePicker = generatePicker<Dayjs>(dayjsGenerateConfig);

export type PickerDateProps = IPickerDateProps<Dayjs>;
export type PickerTimeProps = IPickerTimeProps<Dayjs>;
export type RangePickerProps = IRangePickerProps<Dayjs>;
